import React, { useState, useEffect } from "react";
import Confetti from "react-confetti";
import { FaGift } from "react-icons/fa";
import {
  ConfettiContainer,
  Overlay,
  CenteredContainer,
  GiftButton,
} from "./Effects.styled";

const Effects = ({ volume }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [audioPlaying, setAudioPlaying] = useState(false);
  const [confetti, setConfetti] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    };

    document.body.style.overflow = "hidden";

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      document.body.style.overflow = "";
    };
  }, []);

  useEffect(() => {
    const audio = document.getElementById("background-audio");
    audio.volume = volume;
  }, [volume]);

  const handlePlayAudio = () => {
    const audio = document.getElementById("background-audio");

    audio
      .play()
      .then(() => {
        setAudioPlaying(true);
        setConfetti(true);
        document.body.style.overflow = "";
      })
      .catch((err) => {
        console.log("Autoplay failed. User interaction may be required.");
      });
  };

  return (
    <>
      {confetti && (
        <ConfettiContainer>
          <Confetti
            width={windowWidth}
            height={windowHeight}
            numberOfPieces={50}
            gravity={0.04}
          />
        </ConfettiContainer>
      )}
      <audio id="background-audio" src="/music.mp3" loop />
      <Overlay visible={!audioPlaying} />
      {!audioPlaying && (
        <CenteredContainer>
          <GiftButton className="drop-anim" onClick={handlePlayAudio}>
            <FaGift />
          </GiftButton>
        </CenteredContainer>
      )}
    </>
  );
};

export default Effects;
